var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCookiesGenreralInformation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,6 L22,6 C22.5522847,6 23,6.44771525 23,7 L23,24 C23,25.1045695 22.1045695,26 21,26 L9,26 C7.8954305,26 7,25.1045695 7,24 L7,7 C7,6.44771525 7.44771525,6 8,6 Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,5.25 C22.9664983,5.25 23.75,6.03350169 23.75,7 L23.75,7 L23.75,20 L22.25,20 L22.25,7 C22.25,6.88165327 22.1677666,6.78251318 22.0573227,6.75660268 L22,6.75 L8,6.75 C7.86192881,6.75 7.75,6.86192881 7.75,7 L7.75,7 L7.75,24 C7.75,24.6903559 8.30964406,25.25 9,25.25 L9,25.25 L10,25.25 L10,26.75 L9,26.75 C7.53746816,26.75 6.34159572,25.6082954 6.25501879,24.1675223 L6.25,24 L6.25,7 C6.25,6.03350169 7.03350169,5.25 8,5.25 L8,5.25 Z",
    fill: "#484848",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,20 L25,24 C25,25.1045695 24.1045695,26 23,26 L10,26 L10.0003321,25.7322434 C10.5979503,25.3863868 11,24.7401452 11,24 L11,24 L11,20 L11,20 L25,20 Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 16,
    x2: 16,
    y2: 16,
    stroke: "#797979",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 13,
    x2: 19,
    y2: 13,
    stroke: "#797979",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10,
    x2: 19,
    y2: 10,
    stroke: "#797979",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCookiesGenreralInformation);
export default __webpack_public_path__ + "static/media/ic-cookies-genreral-information.cb205bf73267d618d9925fb9d6889737.svg";
export { ForwardRef as ReactComponent };